<template>
  <div class="contents">
    <div class="content_map">
      <NJNav></NJNav>
      <div class="tablist_item">
        <div class="items" :class="[{active: activeName == item.name}]" v-for="item in itemList" :key="item.id" @click="tabItemClick(item)">{{ item.name }}</div>
      </div>
      <div v-if="machineryShow">
        <AreaNjNums></AreaNjNums>
      </div>
      <!-- <div v-if="mapShow">
        <MachineryWorkAreaMap></MachineryWorkAreaMap>
      </div> -->
    </div>
  </div>
</template>
<script>
import Gmap from '../../map/js/fzTianmap.js'
import markerclusterer from '../../map/js/google_markerclusterer.js'
import Http from '../../Serves/net-http.js'
import Api from '../../Serves/net-api.js'
import NJNav from '../Index/view/NJNav.vue'
import AreaNjNums from './AreaNjNums.vue'
export default {
  components: {
    NJNav,
    AreaNjNums
  },
  data(){
    return{
      itemList: [
        {
          id: 1,
          name: '作业统计'
        },
        {
          id: 2,
          name: '地图展示'
        }
      ],
      activeName: '作业统计',
      machineryShow: true,
      mapShow: false
    }
  },
  mounted(){
    
  },
  methods:{
    tabItemClick (item) {
      this.activeName = item.name
      if (item.id === 2) {
        this.machineryShow = false
        this.mapShow = true
      } else {
        this.machineryShow = true
        this.mapShow = false
      }
    }
  }
}
</script>
<style scoped>
  .contents{
    width: 100%;
    height: 100%;
    /* margin: 0 auto; */
  }
  .content_map{
    width: 98%;
    margin: 0 auto;
  }
  .tablist_item {
		display: flex;
		margin-bottom: 20px;
	}
	.items {
		width: 110px;
		height: 45px;
		background-color: #f4f4f4;
		color: #000;
		font-size: 18px;
		text-align: center;
		line-height: 45px;
		margin-right: 10px;
		border-radius: 2px;
		cursor: pointer;
	}
	.items.active {
		width: 110px;
		height: 45px;
		background-color: #0048c2;
		color: #FFFFFF;
		font-size: 18px;
		text-align: center;
		line-height: 45px;
		border-radius: 2px;
	}
</style>




// WEBPACK FOOTER //
// src/components/MachineryDistribution/MachineryWorkArea.vue